import MaterialTable, { MTableBody, MTableToolbar } from '@material-table/core';
import { TableContainer } from '@mui/material';
import { RecommendedMedicalTypeCell } from './MedicalTypeCell';
import { RecommendedMedicalDescriptionCell } from './MedicalDescriptionCell';
import styles from './styles';
import CellButton from './CellButton';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { createConsult } from './Api/createConsult';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';

const getNoRecommendationsText = (consult_type) =>{
    switch (consult_type){
        case 'chronic_care_consult':
            return "No recommended medicals found. Patient needs to enroll into a chronic care plan first."
        case 'workplace_disease_consult':
            return "No recommended medicals found. Patient needs to enroll into a workplace disease plan first."
        default:
            return "No recommended medicals found."
    }
}
const RecommendedSubTable = ({ booking, patient, data, activityId, episodeOfCareId }) => {
    const classes = styles();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const noRecommendationsText = getNoRecommendationsText(booking.consult_type)

    const handleProceed = (rowData) => {
        createConsult(
            booking.booking_id,
            patient,
            rowData.tariff_code,
            rowData?.medical_type,
            activityId,
            episodeOfCareId
        )
            .then((res) => {
                enqueueSnackbar('Registration Successful', { variant: 'success' });
                navigate('/dashboard');
            })
            .catch((err) => {
                enqueueSnackbar('Failed to create consult', { variant: 'error' });
            });
    };
    const columns = [
        {
            field: 'consult_type',
            render: (rowData) => <RecommendedMedicalTypeCell rowData={rowData} />,
        },

        {
            field: 'medical_description',
            render: (rowData) => <RecommendedMedicalDescriptionCell rowData={rowData} />,
        },

        {
            field: 'action_proceed',
            render: (rowData) => (
                <CellButton label="Proceed" onClick={(event) => handleProceed(rowData)} />
            ),
        },
    ];

    return data.length > 0 ? (
        <MaterialTable
            title={<div className={classes.recommendedHeader}>Recommended Medical</div>}
            columns={columns}
            data={data}
            options={{
                showTitle: true,
                showEmptyDataSourceMessage: true,
                filtering: false,
                header: false,
                paging: false,
                search: false,
                selection: false,
                pageSize: data.length,
            }}
            components={{
                Container: (props) => (
                    <div>
                        <TableContainer {...props} className={classes.recommendedContainer} />
                    </div>
                ),
            }}
            h
        />
    ) : (
        <div>
            <>
                <div>{noRecommendationsText}</div>
                <Button
                    onClick={() => navigate(`/dashboard`)}
                    sx={{
                        marginTop: '24px',
                        position: 'absolute',
                        right: 8,
                    }}
                    variant="contained"
                >
                    Go to Dashboard
                </Button>
            </>
        </div>
    );
};

export default RecommendedSubTable;
